/*
  Initialises the product gallery's middle carousel.

  The markup for it is built in snippets/product-media-gallery-content.liquid
  (the .swiper Product_media_slider that opens after the 2nd visible media item
  and closes before the second-last), and product.css fully styles its dots.
  Nothing in the theme ever created the Swiper, so the slides were laid out by
  CSS alone and the dots container sat empty. Worse, the explainer carousel's
  pagination selector was document-wide, so it claimed this empty container and
  its dots appeared here while driving a section far below.

  Pagination is scoped to each slider element, never a bare class selector.
*/
(function () {
  function init() {
    document.querySelectorAll('.Product_media_slider').forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;
      if (!el.querySelector('.swiper-slide')) return;

      new Swiper(el, {
        rewind: true,
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchOverflow: true,
        threshold: 10,
        observer: true,
        observeParents: true,
        grabCursor: true,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  }

  // swiper-bundle.min.js is loaded with defer from snippets/scripts.liquid, so
  // it may not be parsed yet. Wait for it rather than depending on tag order.
  var tries = 0;
  (function ready() {
    if (window.Swiper) return init();
    if (++tries > 60) return;
    setTimeout(ready, 50);
  })();

  document.addEventListener('shopify:section:load', function () {
    if (window.Swiper) init();
  });
})();
